namespace Matrix.Data {
    export interface PartyRelationshipRow {
        PartyCode?: string;
        RelatedPartyCode?: string;
        RelationshipTypeCode?: string;
        Status?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
        PartyName?: string;
        PartyRowId?: number;
        RelatedPartyName?: string;
        RelatedPartyRowId?: number;
        RelationshipTypeName?: string;
        RelationshipGroup?: string;
        RelationshipTypeStatus?: string;
        RelationshipTypeRowId?: number;
    }

    export namespace PartyRelationshipRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Data.PartyRelationship';
        export const deletePermission = 'DataAdmin:Party';
        export const insertPermission = 'DataAdmin:Party';
        export const readPermission = 'Read:Party';
        export const updatePermission = 'DataAdmin:Party';

        export declare const enum Fields {
            PartyCode = "PartyCode",
            RelatedPartyCode = "RelatedPartyCode",
            RelationshipTypeCode = "RelationshipTypeCode",
            Status = "Status",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder",
            PartyName = "PartyName",
            PartyRowId = "PartyRowId",
            RelatedPartyName = "RelatedPartyName",
            RelatedPartyRowId = "RelatedPartyRowId",
            RelationshipTypeName = "RelationshipTypeName",
            RelationshipGroup = "RelationshipGroup",
            RelationshipTypeStatus = "RelationshipTypeStatus",
            RelationshipTypeRowId = "RelationshipTypeRowId"
        }
    }
}
